import Headers from './components/Headers.vue'
import Footers from './components/Footers.vue'
import Hero from './components/Hero.vue'
import Breadcrumb from './components/Breadcrumb.vue'
import Swiper from './components/Swiper.vue'
import Btn from './components/Btn.vue'
import { createApp } from 'vue'

export default function partials(){
  return new Promise((resolve) => {
    const app = createApp({
      components: {
        Headers: Headers,
        Footers: Footers,
        Hero: Hero,
        Breadcrumb: Breadcrumb,
        Swiper: Swiper,
        Btn: Btn,
      }
    });
    
    // Vue.jsを#appにマウント
    app.mount('#app');
    resolve();
  });
}
